export default {
  registration: () => '/registration',
  permInvite: () => '/perm-invite',
  invite: () => '/invite',
  root: () => '/',
};
